var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-regular"},[_c('div',{staticClass:"loading-regular-bounce loading-regular-bounce1"}),_vm._v(" "),_c('div',{staticClass:"loading-regular-bounce loading-regular-bounce2"}),_vm._v(" "),_c('div',{staticClass:"loading-regular-bounce loading-regular-bounce3"})])
}]

export { render, staticRenderFns }